// import dama from "/modules/dama.js";
// import apiDrupal from "./api.js";
// const dm = new dama();
import { loadLayout } from "./layouts";
import * as AOS from 'aos'
import 'aos/dist/aos.css'

declare global {
    interface Window {
        drupalSettings: any;
        currentLang?: string;
    }
}

// const api = new apiDrupal();
export const page = async () => {
    /* ON LOAD */
    let currentLang = checkLang()
    window.currentLang = currentLang

    loadLayout()
    removeTagTitle()
    translate404Page()
    AOS.init({
        once: true,
        duration: 1000
    })
}

function removeTagTitle() {
    let refTitle = document.querySelector('.block-page-title-block h1')
    if (refTitle) refTitle.remove()
}

export const checkLang = (): string => {
    let path = window.location.pathname.split('/')
    if (path.includes('es')) return 'es'
    if (path.includes('en')) return 'en'
    return 'es'
}

function translate404Page() {
    let refContainer = document.querySelector('.p404')

    const changeText = () => {
        let refDesc = refContainer.querySelector('.p404__description')
        let refBtn = refContainer.querySelector('.p404__btn')
        refDesc.innerHTML = 'The requested page is not available'
        refBtn.innerHTML = 'Go back'
    }
    if (refContainer && window.currentLang == 'en') changeText()
}

export function setCurrentPage(currentPage: string) {
    localStorage.setItem('currentPage', currentPage)
}